import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section className="banner_parcheesi banner_onsite text_white">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/onsite/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={422}
                height={152}
              />
            </div>
            <p>
              In a busy world where nobody has time to socialize due to hectic
              routines. Even we are unable to interact with people who we see
              often in our locality. OnSite Social is a revolutionary mobile
              application developed by TekRevol, designed to bridge the gap
              between the physical and digital worlds. It facilitates the users
              with meaningful connections according to their real-time
              locations.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/onsite-social/id1663432913">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={7}
            className="my-auto text-center offset-xl-1 offset-lg-0 offset-xxl-0 "
          >
            <div className="banner_img_onsite">
              <StaticImage
                src="../../../images/case-studies/onsite/monkey.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={889}
                height={733}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
